<template>
  <div>
    <div class="columns is-multiline is-gapless is-full-height"
    style="overflow: visible; padding: 0.5rem;">
      <div class="full-width column is-12">
        <h2>Emails</h2>
        <div class="columns is-gapless">
          <div class="column"> 
            <v-select
            class="floating-label full-width"
            placeholder="Libellé"
            :opened.sync="email.opened"
            v-model="email.data.rel_type_id"
            :items="email_attr">
            </v-select>
            <!-- @input.once="set_push(email)" -->
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="email.data.rel_type_id == 0"
            @click="edit(email.data.rel_type_id)">
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(1)">
              <i class="plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width column is-12">
        <h2>Numéro</h2>
        <div class="columns is-gapless">
          <div class="column">
            <v-select
            class="floating-label full-width"
            placeholder="Libellé"
            :opened.sync="phone.opened"
            v-model="phone.data.rel_type_id"
            :items="phone_attr">
            </v-select>
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="phone.data.rel_type_id == 0"
            @click="edit(phone.data.rel_type_id)">
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(2)">
              <i class="plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width column is-12">
        <h2>Adresse</h2>
        <div class="columns is-gapless">
          <div class="column"> 
            <v-select
            class="floating-label full-width"
            placeholder="Libellé"
            :opened.sync="address.opened"
            v-model="address.data.rel_type_id"
            :items="address_attr">
            </v-select>
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="address.data.rel_type_id == 0"
            @click="edit(address.data.rel_type_id)">
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(3)">
              <i class="plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width column is-12">
        <h2>Organisation</h2>
        <div class="columns is-gapless">
          <div class="column is-2">
            <v-select
            class="floating-label full-width"
            placeholder="Type"
            :opened.sync="organization.type_opened"
            v-model="organization.type_id"
            :items="organization_attr"
            @input="onOrgTypeSelect($event)"
            >
            </v-select>
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="organization.type_id == 0"
            @click="edit(organization.type_id)"
            >
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(5)">
              <i class="plus"></i>
            </div>
          </div>
          <div class="column">
            <v-select
            class="floating-label full-width"
            placeholder="Rôle"
            :opened.sync="organization.opened"
            v-model="organization.data.rel_type_id"
            :items="get_attributes(organization.type_id)"w
            >
            </v-select>
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="organization.data.rel_type_id == 0"
            @click="edit(organization.data.rel_type_id)">
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(organization.type_id)">
              <i class="plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width column is-12">
        <h2>Groupe</h2>
        <div class="columns is-gapless">
          <div class="column is-2">
            <v-select
            class="floating-label full-width"
            placeholder="Type"
            :opened.sync="group.type_opened"
            v-model="group.type_id"
            :items="group_attr"
            @input="onGroupTypeSelect($event)">
            </v-select>
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="group.type_id == 0"
            @click="edit(group.type_id)">
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(6)">
              <i class="plus"></i>
            </div>
          </div>
          <div class="column">
            <v-form-dropdown
            class="input-control no-overflow full-width"
            placeholder="Groupe"
            v-model="group.data.value"
            :opened.sync="group.opened"
            :filter="group.input"
            :display="group.display"
            :items="group.items"
            :min_letters="0"
            @click.stop.prevent
            @filter="onGroupFilter($event)"
            @input="function (item_id, item) {
              onGroupSelect(item_id, item)
            }">
            </v-form-dropdown>
          </div>
          <div class="column is-narrow add-btn">
            <div class="button"
            :disable="group.data.value == 0"
            @click="edit(group.data.value)">
              <i class="pencil"></i>
            </div>
            <div class="button"
            @click="add(group.type_id)">
              <i class="plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width column is-12">
        <v-modal 
        v-model="modal_open"
        class="is-half"
        style="max-height0: 25%">
          <div class="rows is-full-height is-gapless">
            <div class="row is-narrow">
              <nav class="navbar primary"
              style="padding: 10px;">
                <div v-if="action == 'add'" class="modal-title">Ajouter un attribut</div>
                <div v-if="action == 'set'" class="modal-title">Modifier un attribut</div>

                <div v-if="action == 'set'" class="button"
                @click="onDel">Supprimer</div>
              </nav>
            </div>
            <div class="row is-full-height"
            style="padding: 10px; overflow: auto;">
              <div class="full-width">
                <v-input 
                class="floating-label full-width"
                placeholder="Texte"
                ref="input"
                :hasReset="false"
                v-model="input">
                <!-- :placeholder="placeholder"> -->
                </v-input>
              </div>
            </div>
            <div class="row is-narrow">
              <nav class="navbar primary">
                  <div
                  class="button primary full-width"
                  style="border: 0;"
                  @click="save">Envoyer</div>
                </nav>
              </nav>
            </div>
          </div>
        </v-modal>
      </div>

      <v-modal
        v-model="del_confirm_dialog_open"
      >
        <div class="v-card"
        style="max-width: 290px;">
          <div class="v-card__title headline">
            Confirmer la suppression?
          </div>

          <!-- <div class="v-card__text">
              Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
          </div> -->

          <div class="v-card__actions">

              <div
                class="button"
                color="green darken-1"
                text
                @click="del_confirm_dialog_open = false"
              >
                Annuler
              </div>

              <div
                class="button"
                color="green darken-1"
                text
                @click="del"
              >
                Confirmer
              </div>
          </div>
        </div>
      </v-modal>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import typeahead from '../components/utils/typeahead.js'

export default {
  data: function () {
    return {
      action: null,
      modal_open: false,
      del_confirm_dialog_open: false,
      input: '',
      edit_id: 0,
      placeholder: '',
      email: {
        data: {
          data_type_id: 3,
          rel_id: 0,
          rel_type_id: 0,
          value: ''
        },
        opened: false
      },
      phone: {
        data: {
          data_type_id: 5,
          rel_id: 0,
          rel_type_id: 0,
          value: ''
        },
        opened: false
      },
      address: {
        data: {
          data_type_id: 4,
          rel_id: 0,
          rel_type_id: 0,
          street: '',
          city: '',
          region: '',
          zip: '',
          country: '',
          extended: ''
        },
        opened: false
      },
      group: {
        data: {
          data_type_id: 7,
          rel_type_id: 0,
          rel_id: 0,
          value: 0
        },
        input: '',
        display: '',
        type_id: 0,
        items: window.groups_index.list,
        type_opened: false,
        opened: false
      },
      organization: {
        data: {
          data_type_id: 8,
          rel_id: 0,
          value: 0,
          rel_type_id: 0,
          service_id: 0
        },
        input: '',
        display: '',
        type_id: 0,
        items: window.orgs_index.list,
        type_opened: false,
        opened: false
      }
    }
  },
  computed: {
    ...Vuex.mapGetters({
      email_attr: 'listAttributesEmail',
      phone_attr: 'listAttributesPhone',
      address_attr: 'listAttributesAddress',
      group_attr: 'listAttributesGroup',
      organization_attr: 'listAttributesOrganization',
      contact_attr: 'listAttributesContact',
      get_attributes: 'listGetAttributes'
    })
  },
  methods: {
    onDel: function () {
      this.del_confirm_dialog_open = true
    },
    del: function () {
      let vm = this
      Vue.http.post(
        global.app_path + 'main.php?action=del_attribute',
        {
          id: this.edit_id,
          token: global.token
        })
      .then((response) => {
        vm.$store.dispatch('get_attributes')
        vm.modal_open = false
        vm.del_confirm_dialog_open = false
      }, (response) => {

      })
    },
    add: function (pid) {
      // console.log(pid)
      this.edit_id = pid
      this.input = ''
      this.action = 'add'
      this.modal_open = true
    },
    edit: function (item_id) {
      let attr = this.$store.state.attributes[item_id]
      this.edit_id = item_id
      this.input = attr.n
      this.action = 'set'
      this.modal_open = true
    },
    save: function () {
      let vm = this
      Vue.http.post(
        global.app_path + 'main.php?action=' + this.action + '_attribute',
        {
          id: this.edit_id,
          value: this.input,
          token: global.token
        })
      .then((response) => {
        vm.$store.dispatch('get_attributes')
        vm.modal_open = false
      }, (response) => {
        // error callback
      })
    },
    get_organization_items: function (type, input) {
      let filter = null

      if (input === '') {
        if (Number(type) === 0) {
          return window.orgs_index.list
        }

        if (window.orgs_index.types[type]) {
          return typeahead.get_display(
            window.orgs_index.types[type],
            window.orgs_index
          )
        }

        return []
      }

      if (type > 0) {
        filter = function (item) {
          return item.type === type
        }
      }

      return typeahead.filter_list(
        input,
        window.orgs_index,
        null,
        filter
      )
    },
    get_group_items: function (type, input) {
      let filter = null

      if (input === '') {
        if (Number(type) === 0) {
          return window.groups_index.list
        }

        if (window.groups_index.types[type]) {
          return typeahead.get_display(
            window.groups_index.types[type],
            window.groups_index
          )
        }

        return []
      }

      if (type > 0) {
        filter = function (item) {
          return item.type === type
        }
      }

      return typeahead.filter_list(
        input,
        window.groups_index,
        null,
        filter
      )
    },
    onGroupTypeSelect: function (item_id) {
      this.group.type_id = Number(item_id)
      this.group.data.value = 0
      this.group.display = ''
      this.group.items = this.get_group_items(
        this.group.type_id,
        this.group.input
      )
    },
    onOrgTypeSelect: function (item_id) {
      this.organization.type_id = Number(item_id)
      this.organization.data.value = 0
      this.organization.display = ''
      this.organization.data.rel_type_id = 0

      this.organization.items = this.get_organization_items(
        this.organization.type_id,
        this.organization.input
      )
    },
    onOrgRoleSelect: function (item_id) {
      this.organization.data.rel_type_id = item_id
    },
    onGroupSelect: function (item_id, item) {
      this.group.data.value = item.id
      this.group.display = item.n
      this.group.type_id = item.type
    },
    onOrgSelect: function (item_id, item) {
      this.organization.data.value = item.id
      this.organization.display = item.n
      this.organization.rel_type_id = 0
      this.organization.type_id = item.type
      this.organization.roles = this.get_attributes(this.organization.type_id)
    },
    onOrgFilter: function (input) {
      this.organization.input = input
      this.organization.items = this.get_organization_items(
        this.organization.type_id,
        this.organization.input
      )
    },
    onGroupFilter: function (input) {
      this.group.input = input
      this.group.items = this.get_group_items(
        this.group.type_id,
        this.group.input
      )
    }
  },
  mounted: function () {
    // this.$store.dispatch('get_accounts')
    // this.$store.dispatch('get_auth_page')
  }
}
</script>
<style>
h2 {
  margin: 0.5em 0 .5em;
  padding-bottom: .4em;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
  color: #286fa3;
  display: block;
  font-size: 1.2rem;
}

i.plus {
  font-size: 1rem;
  line-height: 2rem;
  position: relative;
}

.add-btn .button{
  margin: 0px;
  padding: 0px 10px;
  display: inline-block;
  line-height: 2rem;
}

.add-btn {
  padding: 0 0.5rem !important;
  margin-top: 0.5rem !important;
}

</style>
